// extracted by mini-css-extract-plugin
module.exports = {"article-section":"ArticleSection_article-section__79WyH","card-grid":"ArticleSection_card-grid__H70Z_"};